import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "@/hooks/useAppSelector";
import { Crown } from "lucide-react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

const WhatsAppButton = () => {
  const phoneNumber = "201100300800";
  const message = encodeURIComponent("dafa3ni ya Mokhtar law sma7t 😂");
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${message}`;
  const laughingEmoji = "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExM3BjcWw5dWdrcG1nY2tmODBoZjFmcThpcnNucGtsdzFzZXo3cnAxeiZlcD12MV9zdGlja2Vyc19zZWFyY2gmY3Q9ZQ/hVlZnRT6QW1DeYj6We/giphy.gif";

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-bold py-3 px-6 rounded-full shadow-lg transition-all"
    >
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
        alt="WhatsApp"
        className="w-6 h-6 mr-2"
      />
      Contact Mokhtar 3shan ydafa3k
      <img
        src={laughingEmoji}
        alt="Laughing Emoji"
        className="w-8 h-8 ml-2"
      />
    </a>
  );
};

export default function Upgrade() {
  const navigate = useNavigate();
  const { blockedFeaturesMessage } = useAppSelector((state) => state.product);

  useEffect(() => {
    if (!blockedFeaturesMessage) {
      // navigate("/");
    }
  }, [blockedFeaturesMessage, navigate]);

  return (
    <div className="container mx-auto p-6 max-w-2xl">
      <Card className="w-full">
        <CardHeader className="text-center">
          <Crown className="w-12 h-12 mx-auto text-yellow-500 mb-4" />
          <CardTitle className="text-2xl">Upgrade Your Plan</CardTitle>
          <CardDescription className="text-red-500">
            {blockedFeaturesMessage ||
              "You've reached the limits of your current plan"}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="text-center space-y-4">
            <p className="text-gray-600">
              Upgrade your plan to unlock unlimited access to all features and
              continue using our service without interruption.
            </p>
            <WhatsAppButton />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}